export const Level1 = () => <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M25.125 28.7856H28.7857" stroke="#1470CC" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
    <path d="M18.1696 28.7856H21.8304" stroke="#1470CC" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
    <path d="M11.2143 28.7856H14.875" stroke="#1470CC" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
</svg>
